module.exports = __webpack_public_path__ + "img/art_1_3.860436ca.png";